import {twJoin} from 'tailwind-merge'

interface IndicatorPartProps {
  isSelected?: boolean
}

export const IndicatorPart = ({isSelected}: IndicatorPartProps) => {
  return (
    <div className={'absolute inset-y-1/2 -left-spacing-16 hidden w-spacing-8 items-center md:flex'}>
      <div
        className={twJoin(
          'h-spacing-80 w-spacing-8 rounded-full transition-all duration-300',
          !isSelected && 'opacity-0 group-hover:opacity-100 group-hover:bg-interactive-glyph-default-primary/15',
          isSelected && 'block bg-interactive-surface-filled-brand-default',
          isSelected && 'group-hover:bg-interactive-surface-filled-brand-hovered',
          isSelected && 'group-active:bg-interactive-surface-filled-brand-pressed',
        )}
      />
    </div>
  )
}
